module.exports = __webpack_public_path__ + "images/serdil-weinmann.png?2aa78afd09f1ca31dd33c0e0d29241df";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/serdil-weinmann.png
// module id = 991
// module chunks = 0